import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export var Auth = /*#__PURE__*/_createClass(function Auth() {
  _classCallCheck(this, Auth);
});
//账号登录
_defineProperty(Auth, "accountlogin", "/api/auth/sign_in");
//短信/手机号登录
_defineProperty(Auth, "phoneLogin", "/api/auth/mobile/sign_in");
//用户退登
_defineProperty(Auth, "uersLogut", "/api/auth/logout");
//用户注册
_defineProperty(Auth, "userRegister", "/api/auth/signup");
//手机注册
_defineProperty(Auth, "phoneRegister", "/api/auth/mobile/mobileSignup");
//刷新登陆标识
_defineProperty(Auth, "refreshToken", "/api/auth/token/refresh");
// 找回密码
_defineProperty(Auth, "userForgotPass", "/api/auth/forget/reset_password");
//第三方登录
_defineProperty(Auth, "thirdLogin", "/api/auth/third_sign_in");
// 会员注销
_defineProperty(Auth, "memberCancellation", "/api/auth/cancelled");
// 通过用户名密码注销接口
_defineProperty(Auth, "cancelledByName", "/api/auth/cancelledByName");
export var Vip = /*#__PURE__*/_createClass(function Vip() {
  _classCallCheck(this, Vip);
});
//获取用户福利信息
_defineProperty(Vip, "getWelfareInfo", "/api/api/center/getMemberInfo");
//获取领取福利奖励
_defineProperty(Vip, "getReward", "/api/api/center/getReward");
//VIP成长值变动明细
_defineProperty(Vip, "getVipChangeInfo", "/api/api/center/getVipChangeInfo");
//获取VIP成长值描述信息
_defineProperty(Vip, "getVipConInfo", "/api/api/center/getVipConInfo");
//VIP详情
_defineProperty(Vip, "getVipInfo", "/api/api/center/getVipInfo");
//获取会员未领取的福利数量
_defineProperty(Vip, "getWelfareCount", "/api/api/center/getWelfareCount");
//会员签到
_defineProperty(Vip, "vipSing", "/api/api/center/vipSing");
//查询签到状态
_defineProperty(Vip, "getVipStatus", "/api/api/center/vipStatus");
export var UserInfo = /*#__PURE__*/_createClass(function UserInfo() {
  _classCallCheck(this, UserInfo);
});
//获取个人信息
_defineProperty(UserInfo, "info", "/api/user/info");
//修改个人信息
_defineProperty(UserInfo, "update", "/api/user/update");
//修改密码
_defineProperty(UserInfo, "updatePhone", "/api/user/bindPhone");
_defineProperty(UserInfo, "updatePassword", "/api/user/updatePassword");
_defineProperty(UserInfo, "updateWithdrawPwd", "/api/user/updateWithdrawPwd");
_defineProperty(UserInfo, "protectWithdraw", "/api/user/withdraw/protect");
// 根据用户名获取手机号码
_defineProperty(UserInfo, "getPhoneNumber", "/api/auth/forget/query_mobile_phone");
// 获取短信验证码接口
_defineProperty(UserInfo, "getPhoneInfoCode", "/api/sms/send");
// 往已绑定的手机号发送短信码
_defineProperty(UserInfo, "getSmsCode", "/api/user/getSmsCode");
// 获取所有游戏平台余额
_defineProperty(UserInfo, "queryAllPlatformBalance", "/api/game/queryAllPlatformBalance");
// 获取vip详情、福利信息
_defineProperty(UserInfo, "getWelfareList", "/api/user/getWelfareList");
// 获取当前vip信息
_defineProperty(UserInfo, "getVipInfo", "/api/user/getVipInfo");
// 获取我的成长值
_defineProperty(UserInfo, "getVipChangeInfo", "/api/user/getVipChangeInfo");
// 签到
_defineProperty(UserInfo, "vipSing", "/api/user/vipSing");
_defineProperty(UserInfo, "getWealList", "/api/user/getWeal");
_defineProperty(UserInfo, "getWealGroup", "/api/user/getWealGroup");
_defineProperty(UserInfo, "receiveAward", "/api/user/receiveAward");
_defineProperty(UserInfo, "getWealCount", "/api/user/getWealCount");
_defineProperty(UserInfo, "getVipOpenStatus", "/api/admin/member/growthLevel/config");
// 获取vip开关
// 获取金币兑换记录
_defineProperty(UserInfo, "getGoldChangeList", "/api/user/coin/page");
// 获取金币描述信息
_defineProperty(UserInfo, "getGoldDesc", "/api/user/coin/goldCoinDescList");
//获取邮箱杨证明
_defineProperty(UserInfo, "getEmailVerifyCode", "/api/email/send");
// 玩家解绑第三方软件
_defineProperty(UserInfo, "unbindThirdApp", "/api/user/unbindThirdApp");
// 玩家绑定第三方软件
_defineProperty(UserInfo, "bindThirdApp", "/api/user/bindThridApp");
export var Bank = /*#__PURE__*/_createClass(function Bank() {
  _classCallCheck(this, Bank);
});
// 绑定银行卡
_defineProperty(Bank, "bindBank", "/api/user/bindCard");
// 解绑银行卡
_defineProperty(Bank, "unBindBank", "/api/user/unbindCard");
// 查询银行卡
_defineProperty(Bank, "bankList", "/api/user/cards");
export var Activity = /*#__PURE__*/_createClass(function Activity() {
  _classCallCheck(this, Activity);
});
//用户点击参加活动
_defineProperty(Activity, "click", "/api/activity/click");
//活动类型列表
_defineProperty(Activity, "typeList", "/api/activity/typeList");
//获取活动列表
_defineProperty(Activity, "list", "/api/activity/list");
//活动详情
_defineProperty(Activity, "detail", "/api/activity/detail");
// 红包雨活动配置
_defineProperty(Activity, "redEnvelopeInfo", "/api/activity/getRedEnvelopeInfo");
// 抢红包
_defineProperty(Activity, "drawRedEnvelope", "/api/activity/drawRedEnvelope");
// 红包明细真实数据
_defineProperty(Activity, "queryWelfareDetail", "/api/activity/queryWelfareDetailList");
// 红包明细虚拟数据
_defineProperty(Activity, "queryUnrealWelfareDetail", "/api/activity/queryUnrealWelfareDetailList");
// 获取红包领取资格
_defineProperty(Activity, "RedEnvelopeCount", "/api/activity/getRedEnvelope");
// 转盘信息
_defineProperty(Activity, "TurntableDetail", "/api/activity/getActivityTurntableDetail");
// 转盘抽奖
_defineProperty(Activity, "drawTurntable", "/api/activity/drawTurntable");
//活动标题
_defineProperty(Activity, "titleList", "/api/activity/titleList");
export var Common = /*#__PURE__*/_createClass(function Common() {
  _classCallCheck(this, Common);
});
//获取极验状态
_defineProperty(Common, "captchaCode", "/api/captcha/code");
//获取短信验证码
_defineProperty(Common, "smsCode", "/api/ms/code");
// 文件上传
_defineProperty(Common, "upload", "/api/file/upload");
// 查询公告消息列表
_defineProperty(Common, "notice", "/api/notice/page");
// 查询公告消息详情
_defineProperty(Common, "detailInfo", "/api/notice/info/");
// 国际化
_defineProperty(Common, "i18n", "/api/messageI18n/international/list");
export var Config = /*#__PURE__*/_createClass(function Config() {
  _classCallCheck(this, Config);
});
//获取银行卡配置
_defineProperty(Config, "bank", "/api/config/bank");
//获取活动相关
_defineProperty(Config, "activity", "/api/config/activity");
//获取个人资料配置
_defineProperty(Config, "getProfile", "/api/config/profile");
//注册相关配置
_defineProperty(Config, "getRegister", "/api/config/register");
//获取系统配置相关
_defineProperty(Config, "getSystem", "/api/config/system");
//获取租户配置相关
_defineProperty(Config, "getTenantConfigApi", "/api/tenant/setting/getConfig");
//虚拟货币相关配置
_defineProperty(Config, "getVirtualCurrency", "/api/config/virtual_currency");
// 虚拟币币种
_defineProperty(Config, "getVirtualCoin", "/api/config/virtual_coin");
//提现相关配置
_defineProperty(Config, "getWithdrawLimit", "/api/config/getWithdrawLimit");
//获取手机国际区号
_defineProperty(Config, "getDialCode", "/api/config/dial_code");
// 获取浮窗列表
_defineProperty(Config, "getFloatList", "/api/tenant/float/list");
//获取域名配置
_defineProperty(Config, "getDomainList", "/api/tenant/domain/list");
// 获取客服配置
_defineProperty(Config, "getCustomerInfo", "/api/customer/customerInfo");
// 活动悬浮窗
_defineProperty(Config, "getActivityFloat", "/api/activity/getActivityFloat");
// 获取ip区域
_defineProperty(Config, "getIpArea", "/api/config/getArea");
// 手动签到
_defineProperty(Config, "signIn", "/api/user/vipSing");
// 查询签到详情
_defineProperty(Config, "getSignInDetail", "/api/activity/findSignDetails");
// 领取神秘嘉奖
_defineProperty(Config, "getMysterious", "/api/activity/clickMysterious");
// 神秘嘉奖详情
_defineProperty(Config, "getMysteriousDetail", "/api/activity/findMysteriousDetails");
export var Withdraw = /*#__PURE__*/_createClass(function Withdraw() {
  _classCallCheck(this, Withdraw);
});
//提现
_defineProperty(Withdraw, "save", "/api/withdraw/save");
//提款订单
_defineProperty(Withdraw, "page", "/api/withdraw/page");
//会员出款打码量审核信息
_defineProperty(Withdraw, "valid", "/api/withdraw/get_valid_withdraw");
//用户取现页面展现信息
_defineProperty(Withdraw, "query", "/api/withdraw/withdrawLimit");
// 查询下单明细
_defineProperty(Withdraw, "get", "/api/withdraw/get");
// 获取国家编码
_defineProperty(Withdraw, "country", "/api/withdraw/getCountry");
export var Game = /*#__PURE__*/_createClass(function Game() {
  _classCallCheck(this, Game);
});
//一级游戏列表
// public static queryFirst = `/api/game/queryAllGameKind`;
//一级游戏列表
_defineProperty(Game, "queryFirst", "/api/game/gameBar");
_defineProperty(Game, "queryNewFirst", "/api/game/gameBarNew");
_defineProperty(Game, "queryFirst6", "/api/tenant/setting/getScenario6");
// 二级游戏列表(免token)
_defineProperty(Game, "querySecond", "/api/game/queryLiveGamePage");
// 二级游戏列表(token)
_defineProperty(Game, "querySecondToken", "/api/game/user/queryLiveGamePage");
//跳转游戏
_defineProperty(Game, "play", "/api/game/play");
//试玩
_defineProperty(Game, "freePlay", "/api/game/freePlay");
//额度全部回收
_defineProperty(Game, "reclaimLiveAmount", "/api/game/reclaimLiveAmount");
//额度自动转换
_defineProperty(Game, "freeTransfer", "/api/game/freeTransfer");
// 玩彩web获取高频彩、低频彩开奖结果
_defineProperty(Game, "lotteryResult", "/api/game/getGameLottyResult");
//KC130获取开奖结果及彩种图片信息
_defineProperty(Game, "lotteryResultInfo", "/api/game/getGameLottyInfo");
// 游戏列表 - 收藏
_defineProperty(Game, "getCollectGame", "/api/game/getCollectGame");
_defineProperty(Game, "collectGame", "/api/game/collectGame");
_defineProperty(Game, "towGameNav", "/api/game/gameList");
_defineProperty(Game, "getGameBetList", "/api/bet/getgetGameData");
// 登录状态获取小游戏参数
_defineProperty(Game, "getGameParamsByToken", "/api/game/otth/gameParams");
// 未登录状态获取小游戏参数
_defineProperty(Game, "getGameParams", "/api/game/free/gameParams");
export var Recharge = /*#__PURE__*/_createClass(function Recharge() {
  _classCallCheck(this, Recharge);
});
//路径
//获取支付方式
_defineProperty(Recharge, "types", "/api/recharge/get_pay_types");
//在线支付
_defineProperty(Recharge, "pay", "/api/recharge/online_pay");
//充值转账
_defineProperty(Recharge, "transfer", "/api/recharge/transfer");
//撤销充值
_defineProperty(Recharge, "revoke", "/api/recharge/revoke");
//获取支付通道和收款账号
_defineProperty(Recharge, "channel", "/api/recharge/get_accounts_channels");
//获取支付限制信息
_defineProperty(Recharge, "config", "/api/recharge/get_recharge_config");
//充值订单
_defineProperty(Recharge, "page", "/api/recharge/page");
//充值订单
_defineProperty(Recharge, "lastOrder", "/api/recharge/getLastOrder");
export var Sport = /*#__PURE__*/_createClass(function Sport() {
  _classCallCheck(this, Sport);
});
// 站内信接口
//直播间举报类型
_defineProperty(Sport, "reportType", "/api/anchor/chatroom/player/load/reportType");
//获取主播列表
_defineProperty(Sport, "match", "/api/anchor/match/player/match");
//热门赛事
_defineProperty(Sport, "liveList", "/api/sports/match/player/liveList");
//获取租户配置
_defineProperty(Sport, "getTenantConfig", "/api/sports/tenant/config/player/getTenantConfig");
//获取租户版本
_defineProperty(Sport, "getConfigVersion", "/api/sports/tenant/config/player/getConfigVersion");
//获取热门数据相关
_defineProperty(Sport, "sportUnionData", "/api/sports/match/player/sportUnionData");
//获取热门数据相关
_defineProperty(Sport, "get", "/api/sports/config/player/get");
//获取活动浮窗
_defineProperty(Sport, "query", "/api/sports/tenant/float/player/query");
//热门比赛视频接口
_defineProperty(Sport, "urlList", "/api/sports/match/player/video/urlList");
//礼物列表
_defineProperty(Sport, "gift", "/api/anchor/kg/player/live/load/gift");
//礼物
_defineProperty(Sport, "presen", "/api/anchor/kg/player/submit/gift/presen");
//聊天室举报
_defineProperty(Sport, "add", "/api/anchor/chatroom/player/report/add");
export var MessageApi = /*#__PURE__*/_createClass(function MessageApi() {
  _classCallCheck(this, MessageApi);
});
// 投注记录
// 获取消息列表
_defineProperty(MessageApi, "list", "/api/user/message/page");
// 获取未读消息数量
_defineProperty(MessageApi, "getCount", "/api/user/message/getCount");
// 删除个人消息
_defineProperty(MessageApi, "remove", "/api/user/message/remove");
// 已读
_defineProperty(MessageApi, "read", "/api/user/message/read");
// 查看消息详情
_defineProperty(MessageApi, "info", "/api/user/message/info/");
// 全部已读
_defineProperty(MessageApi, "readAll", "/api/user/message/readAll");
// 个人弹窗消息
_defineProperty(MessageApi, "propMessage", "/api/user/popMessage/list");
export var BetRecord = /*#__PURE__*/_createClass(function BetRecord() {
  _classCallCheck(this, BetRecord);
});
// 交易记录
// 获取游戏投注详情
_defineProperty(BetRecord, "list", "/api/bet/getBetRecords");
// 获取游戏投注信息
_defineProperty(BetRecord, "report", "/api/bet/getBetReport");
// 获取所有二级游戏
_defineProperty(BetRecord, "kindList", "/api/game/queryGameKindList");
export var TransRecordApi = /*#__PURE__*/_createClass(function TransRecordApi() {
  _classCallCheck(this, TransRecordApi);
});
// app版本控制
// 账变记录
_defineProperty(TransRecordApi, "BillFlow", "/api/user/bill/getBillFlow");
// 充值记录
_defineProperty(TransRecordApi, "rechargerList", "/api/user/bill/getRechargerOrderList");
// 提现记录
_defineProperty(TransRecordApi, "withdrawList", "/api/user/bill/getWithdrawList");
// 额度转换记录
_defineProperty(TransRecordApi, "quotaList", "/api/user/bill/getGameTransferList");
// 获取账变类型
_defineProperty(TransRecordApi, "tranTypes", "/api/user/bill/getTranTypes");
export var DownloadApi = /*#__PURE__*/_createClass(function DownloadApi() {
  _classCallCheck(this, DownloadApi);
});
// app版本控制
_defineProperty(DownloadApi, "version", "/api/download/getAppPackage");
export var BannerApi = /*#__PURE__*/_createClass(function BannerApi() {
  _classCallCheck(this, BannerApi);
});
// 意见反馈
_defineProperty(BannerApi, "banner", "/api/banner/list");
// 玩彩中奖排行榜
_defineProperty(BannerApi, "lotteryData", "/api/game/lotteryData");
export var FeedbackApi = /*#__PURE__*/_createClass(function FeedbackApi() {
  _classCallCheck(this, FeedbackApi);
});
// 直播
// 提交意见反馈
_defineProperty(FeedbackApi, "add", "/api/user/feedback/add");
// 意见反馈类型
_defineProperty(FeedbackApi, "type", "/api/user/feedback/type");
export var LiveApi = /*#__PURE__*/_createClass(function LiveApi() {
  _classCallCheck(this, LiveApi);
});
// 借呗 相关接口
_defineProperty(LiveApi, "LiveList", "/api/sport/match/list");
_defineProperty(LiveApi, "anchorList", "/api/sport/match/player/match");
_defineProperty(LiveApi, "MatchVideos", "/api/sport/match/video/urlList");
export var loanApi = /*#__PURE__*/_createClass(function loanApi() {
  _classCallCheck(this, loanApi);
});
// 余额宝 相关接口
// 查询借呗额度
_defineProperty(loanApi, "getLoan", "/api/user/loan/getLoan");
// 借款
_defineProperty(loanApi, "lend", "/api/user/loan/lend");
// 还款
_defineProperty(loanApi, "repay", "/api/user/loan/repay");
// 借款记录
_defineProperty(loanApi, "record", "/api/user/loan/record");
export var yuebaoApi = /*#__PURE__*/_createClass(function yuebaoApi() {
  _classCallCheck(this, yuebaoApi);
});
// 多币种 钱包相关
// 查询当前用户的余额宝信息
_defineProperty(yuebaoApi, "info", "/api/yubao/info");
// 转入
_defineProperty(yuebaoApi, "transferIn", "/api/yubao/transferIn");
// 转出
_defineProperty(yuebaoApi, "transferOut", "/api/yubao/transferOut");
// 查询收益记录
_defineProperty(yuebaoApi, "interestHistory", "/api/yubao/interestHistory");
export var walletApi = /*#__PURE__*/_createClass(function walletApi() {
  _classCallCheck(this, walletApi);
});
// 已开启钱包
_defineProperty(walletApi, "userList", "/api/wallet/wallet_enable_list");
// 单币种开关
_defineProperty(walletApi, "singleSwitch", "/api/wallet/wallet_update");
// 批量排序 开关
_defineProperty(walletApi, "transferOut", "/api/yubao/transferOut");
// 币种币种列表
_defineProperty(walletApi, "pltList", "/api/wallet/wallet_list");
export var SportBetRecords = /*#__PURE__*/_createClass(function SportBetRecords() {
  _classCallCheck(this, SportBetRecords);
});
// 获取体育注单
_defineProperty(SportBetRecords, "orders", "/api/bet/getSportBetRecords");
export var TimezoneApi = /*#__PURE__*/_createClass(function TimezoneApi() {
  _classCallCheck(this, TimezoneApi);
});
// 获取时区列表
_defineProperty(TimezoneApi, "timezoneList", "/api/messageI18n/international/list");
export var Help = /*#__PURE__*/_createClass(function Help() {
  _classCallCheck(this, Help);
});
// 获取帮助中心列表
_defineProperty(Help, "helpList", "/api/helpCenter/list");
export var Task = /*#__PURE__*/_createClass(function Task() {
  _classCallCheck(this, Task);
});
// 任务板块
_defineProperty(Task, "types", "/api/mission/types");
// 获取任务列表
_defineProperty(Task, "list", "/api/mission/list");
// 参加任务
_defineProperty(Task, "apply", "/api/mission/apply");
_defineProperty(Task, "applyExt", "/api/mission/applyExt");
export var Turntable = /*#__PURE__*/_createClass(function Turntable() {
  _classCallCheck(this, Turntable);
});
// 查询转盘活动
_defineProperty(Turntable, "getActivityTurntable", "/api/activity/getActivityTurntable");
// 转盘抽奖
_defineProperty(Turntable, "drawTurntable", "/api/activity/drawTurntable");
// 转盘活动优惠获奖明细
_defineProperty(Turntable, "getTurntableDetailList", "/api/activity/getTurntableDetailList");
// 获取转盘奖品明细
_defineProperty(Turntable, "getTurntablePrize", "/api/activity/getTurntablePrize");
export var PromotionCode = /*#__PURE__*/_createClass(function PromotionCode() {
  _classCallCheck(this, PromotionCode);
});
// 宝箱
// 推广码
_defineProperty(PromotionCode, "getPromotionCode", "/api/redeem/draw");
export var TreasureBox = /*#__PURE__*/_createClass(function TreasureBox() {
  _classCallCheck(this, TreasureBox);
});
// 宝箱佣金结算
_defineProperty(TreasureBox, "treasureBoxCommissionSettle", "/api/commission/treasureBoxCommissionSettle");
// 获取宝箱数据
_defineProperty(TreasureBox, "queryTreasureBoxCommission", "/api/commission/queryTreasureBoxCommission");
// 关闭宝箱接口
_defineProperty(TreasureBox, "treasureBoxClose", "/api/commission/treasureBoxClose");